module.exports = __webpack_public_path__ + "img/pinIcon.d6006014.svg";